import { fork } from 'redux-saga/effects';

import { appSagas } from './modules/app/sagas/app-sagas';
import { authSagas } from '@rosetta/react-auth';
import { exportSagas } from './modules/launchpad/sagas/export-sagas';
import { goalsSagas } from './modules/launchpad/sagas/goals-sagas';
import { launchpadSagas } from './modules/launchpad/sagas/launchpad-sagas';
import { passwordChangeSagas } from './modules/login/sagas/password-change-sagas';
import { preferencesSagas } from './modules/preferences/sagas/preferences-sagas';
import { questionnaireSagas } from './modules/questionnaire/sagas/questionnaire-sagas';
import { registerSagas } from './modules/register/sagas/register-sagas';
import { ssoLoginSagas } from './modules/login/sagas/sso-login-sagas';

export function* rootSaga() {
  yield fork(appSagas);
  yield fork(authSagas);
  yield fork(exportSagas);
  yield fork(goalsSagas);
  yield fork(launchpadSagas);
  yield fork(passwordChangeSagas);
  yield fork(preferencesSagas);
  yield fork(questionnaireSagas);
  yield fork(registerSagas);
  yield fork(ssoLoginSagas);
}



// WEBPACK FOOTER //
// ./src/root-saga.js